"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHeadline = exports.HeadlineWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const setContainerWidth = width => {
  switch (width) {
    case 'wide':
      return (0, _layout.setContainer)({
        size: 'xl'
      });
    default:
      return (0, _layout.setContainer)({
        size: 'sm'
      });
  }
};
const setFontSize = size => {
  switch (size) {
    case 'small':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFontSizes)({
        xs: '40px',
        lg: '48px'
      })}
        @media (min-width: ${_breakpoints.BREAKPOINTS.xs}px) {
          line-height: 35px;
        }
        @media (min-width: ${_breakpoints.BREAKPOINTS.lg}px) {
          line-height: 45px;
        }
      `;
    case 'normal':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFontSizes)({
        xs: '50px',
        lg: '68px'
      })}
        @media (min-width: ${_breakpoints.BREAKPOINTS.xs}px) {
          line-height: 45px;
        }
        @media (min-width: ${_breakpoints.BREAKPOINTS.lg}px) {
          line-height: 65px;
        }
      `;
    case 'large':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFontSizes)({
        xs: '50px',
        lg: '84px'
      })}
        @media (min-width: ${_breakpoints.BREAKPOINTS.xs}px) {
          line-height: 45px;
        }
        @media (min-width: ${_breakpoints.BREAKPOINTS.lg}px) {
          line-height: 80px;
        }
      `;
    case 'flex':
      return;
    default:
      return (0, _styledComponents.css)`
        font-size: 20px;
        font-weight: normal;
        line-height: 22px;
      `;
  }
};
const setFontStyle = weight => {
  switch (weight) {
    case 'light':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFont)({
        condensed: true
      })}
      `;
    case 'regular':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFont)({
        bold: true
      })}
      `;
    case 'bold':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFont)({
        headline: true
      })}
      `;
    case 'deville':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFont)({
        display: true
      })};
        letter-spacing: 0.012em;
      `;
    case 'helvetica':
      return (0, _styledComponents.css)`
        font-family: 'monotype-helvetica-display';
        letter-spacing: 0.012em;
      `;
    case 'helvetica-medium':
      return (0, _styledComponents.css)`
        font-family: 'monotype-helvetica-display-medium';
        letter-spacing: 0.012em;
      `;
    case 'helvetica-bold':
      return (0, _styledComponents.css)`
        font-family: 'monotype-helvetica-display-bold';
        letter-spacing: 0.012em;
      `;
    case 'trade-gothic':
      return (0, _styledComponents.css)`
        font-family: 'trade-gothic';
      `;
    default:
      return (0, _styledComponents.css)`
        font-family: 'univers-black', sans-serif;
      `;
  }
};
const HeadlineWrapper = _styledComponents.default.div`
  position: relative;
`;
exports.HeadlineWrapper = HeadlineWrapper;
const StyledHeadline = _styledComponents.default.h1`
  color: ${props => props.fontColor};
  will-change: opacity;
  ${props => setContainerWidth(props.containerWidth)};
  ${props => setFontSize(props.fontSize)};
  ${props => setFontStyle(props.fontStyle)};
  ${props => props.customFontSizeDesktop && (0, _styledComponents.css)`
      font-size: ${props.customFontSizeDesktop}px;
      line-height: ${props.customFontSizeDesktop}px;
    `};
  ${props => props.customFontSizeMobile && (0, _styledComponents.css)`
      @media (max-width: ${_breakpoints.BREAKPOINTS.xs}px) {
        font-size: ${props.customFontSizeMobile}px;
        line-height: ${props.customFontSizeMobile}px;
      }
    `};
  ${props => props.textAlignment && (0, _styledComponents.css)`
      text-align: ${props.textAlignment};
    `};
`;
exports.StyledHeadline = StyledHeadline;
//# sourceMappingURL=styles.js.map